import { CHANGESTATUS, SEARCH } from "./actionType";

export const searchBook = (value) => {
 return {
  type: SEARCH,
  payload: value,
 };
};

export const changeStatus = (status) => {
 return {
  type: CHANGESTATUS,
  payload: status,
 };
};
